<template>
  <v-autocomplete 
  :items="items" 
  item-text="family" 
  label="Choose Font"
  v-bind:value="value"
   v-on:change="$emit('input', $event)"
   solo dark v-if="!loading">
    <template v-slot:selection="data">
      <span
        :style="{
                 fontFamily: data.item.family,
                 fontSize: '15px'
             }"
      >{{data.item.family}}</span>
    </template>
    <template v-slot:item="{item, index}">
      <v-list-item-content>
        <span
          :style="{
                 fontFamily: item.family,
                 fontSize: '25px'
             }"
        >{{item.family}}</span>
      </v-list-item-content>
    </template>
  </v-autocomplete>
  <v-progress-circular color="orange" v-else indeterminate></v-progress-circular>
</template>

<script>
const API_KEY = "AIzaSyDEUcqc3ZXwo1gEmoaZHWV0J7C3ulLR2og";

export default {
  data: () => ({
    loading: true,
    items: []

  }),
  props: {
    value : {
      type: String,
    }
  },
  methods: {
    async fetchFonts() {
      try {
        let response = await fetch(
          `https://www.googleapis.com/webfonts/v1/webfonts?key=${API_KEY}`
        );
        let result = await response.json();

        this.items = result.items;

        let styleNode = document.createElement("style");

        this.items.forEach(item => {
          
          let fontFamily = ` @font-face { font-family: '${item.family}';`;

          for (let key in item.files) {
            fontFamily += `src: url('${item.files[key].replace('http:', '')}') format("truetype");`;
          }
          fontFamily += `}`;

          let importFont = document.createTextNode(fontFamily);
          styleNode.appendChild(importFont);
        });

        document.getElementsByTagName("head")[0].appendChild(styleNode);
        //console.log(this.items);
        //console.log(result);
        this.loading = false;
      } catch (e) {
        alert(e);
      }
    }
  },
  created() {
    this.fetchFonts();
  }
};
</script>